webpackJsonp([76],{

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 2427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的测试安卓APKID', 'integer', 'blur', false), { min: 1 })]
};

var formRules = {
  title: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入名称', 'string'))],
  vision: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入APK版本', 'string'))],
  force_update: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择是否强制升级', 'integer'))],
  loadurl: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请上传APK包', 'string'))],
  apk_signature: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入APK签名', 'string'))],
  enable_hot_update: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择是否开启热更新', 'integer'))],
  force_hot_update: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择是否强制热更新', 'integer'))]
};

/***/ }),

/***/ 2890:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform_androidapk_test_rules_js__ = __webpack_require__(2427);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var APP_TYPE_ALG = 1;
var APP_TYPE_CLB = 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      id: 0,
      formRules: __WEBPACK_IMPORTED_MODULE_4__platform_androidapk_test_rules_js__["a" /* formRules */],
      uploading: false,
      form: {
        title: null,
        vision: null,
        ios_version: null,
        ios_loadurl: null,
        changelog: null,
        force_update: 0,
        type: 0,
        loadurl: null,
        apk_signature: null,
        app_type: APP_TYPE_ALG,
        enable_hot_update: 0,
        force_hot_update: 0
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.platformAndroidapkTest.options;
    }
  }), {
    isAlg: function isAlg() {
      return Number(this.form.app_type) === APP_TYPE_ALG;
    },
    isClb: function isClb() {
      return Number(this.form.app_type) === APP_TYPE_CLB;
    },
    appTypeLabel: function appTypeLabel() {
      return this.isClb ? '查理宝' : '爱零工';
    },
    tablePath: function tablePath() {
      return {
        path: '/platform-androidapk-test/table',
        query: { app_type: String(this.form.app_type || APP_TYPE_ALG) }
      };
    },
    computedFormRules: function computedFormRules() {
      var rules = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.formRules);
      if (!this.isAlg) {
        delete rules.apk_signature;
      }
      if (!this.isClb) {
        delete rules.enable_hot_update;
        delete rules.force_hot_update;
      } else if (Number(this.form.enable_hot_update) !== 1) {
        delete rules.force_hot_update;
      }
      return rules;
    }
  }),
  watch: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    resolveAppTypeFromRoute: function resolveAppTypeFromRoute() {
      var queryType = this.$route.query.app_type;
      if (queryType !== undefined && queryType !== null && queryType !== '') {
        return Number(queryType) === APP_TYPE_CLB ? APP_TYPE_CLB : APP_TYPE_ALG;
      }
      return APP_TYPE_ALG;
    },
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id);
      } else {
        this.form.app_type = this.resolveAppTypeFromRoute();
      }
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.onLoad();
    },
    setForm: function setForm(id) {
      var _this = this;

      request.page('getPlatformAndroidapkTestDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        filter.setLoop(_this.form, data);
        if (data.app_type === undefined || data.app_type === null || data.app_type === '') {
          _this.form.app_type = APP_TYPE_ALG;
        } else {
          _this.form.app_type = Number(data.app_type) === APP_TYPE_CLB ? APP_TYPE_CLB : APP_TYPE_ALG;
        }
        _this.form.enable_hot_update = Number(data.enable_hot_update) === 1 ? 1 : 0;
        _this.form.force_hot_update = Number(data.force_hot_update) === 1 ? 1 : 0;
      });
    },
    onEnableHotUpdateChange: function onEnableHotUpdateChange(value) {
      if (Number(value) !== 1) {
        this.form.force_hot_update = 0;
      }
    },
    uploadRequest: function uploadRequest(obj) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var file, ext, params, res, uploadUrl, contentType, fileUrl;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.uploading = true;
                _context.prev = 1;
                file = obj.file;
                ext = file.name.split('.').pop().toLowerCase();

                // 获取签名URL

                params = {
                  ext: ext,
                  content_type: file.type || 'application/vnd.android.package-archive'
                };
                _context.next = 7;
                return request.common('getAndroidApkSignedUrl', params);

              case 7:
                res = _context.sent;

                if (!(res.status === 200)) {
                  _context.next = 18;
                  break;
                }

                uploadUrl = res.data.signedUrl;
                contentType = res.data.content_type;
                fileUrl = res.data.url;

                // 使用 PUT 方法上传文件到签名URL

                _context.next = 14;
                return fetch(uploadUrl, {
                  method: 'PUT',
                  headers: new Headers({
                    'Content-Type': contentType
                  }),
                  body: file
                });

              case 14:

                _this2.form.loadurl = fileUrl;
                _this2.$message.success('上传成功');
                _context.next = 19;
                break;

              case 18:
                _this2.$message.error('获取上传地址失败');

              case 19:
                _context.next = 25;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context['catch'](1);

                console.error('上传失败:', _context.t0);
                _this2.$message.error('上传失败: ' + (_context.t0.message || '未知错误'));

              case 25:
                _context.prev = 25;

                _this2.uploading = false;
                return _context.finish(25);

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 21, 25, 28]]);
      }))();
    },
    handleRemove: function handleRemove(index) {
      this.form.loadurl = '';
    },
    getForm: function getForm() {
      var data = filter.copyJson(this.form);
      data.app_type = Number(data.app_type) === APP_TYPE_CLB ? APP_TYPE_CLB : APP_TYPE_ALG;
      if (data.app_type === APP_TYPE_CLB) {
        data.type = 0;
        data.apk_signature = '';
        data.enable_hot_update = Number(data.enable_hot_update) === 1 ? 1 : 0;
        data.force_hot_update = data.enable_hot_update === 1 && Number(data.force_hot_update) === 1 ? 1 : 0;
      } else {
        data.enable_hot_update = 0;
        data.force_hot_update = 0;
      }
      return data;
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this3.id ? _this3.update(_this3.id) : _this3.create();
        } else {
          _this3.$message.error('提交内容填写不正确！');
        }
      });
    },
    create: function create() {
      var _this4 = this;

      request.common('createPlatformAndroidapkTestData', this.getForm()).then(function (res) {
        _this4.$confirm(_this4.$route.meta.title + '成功, 是否继续添加？', '提示', { type: 'success' }).then(function () {
          _this4.$refs.form.resetFields();
          _this4.form.app_type = _this4.resolveAppTypeFromRoute();
          _this4.form.enable_hot_update = 0;
          _this4.form.force_hot_update = 0;
        }, function () {
          _this4.$router.push(_this4.tablePath);
        });
      });
    },
    update: function update(id) {
      var _this5 = this;

      request.common('updatePlatformAndroidapkTestData', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ id: id }, this.getForm())).then(function (res) {
        _this5.$confirm(_this5.$route.meta.title + '成功, 是否前往列表页面？', '提示', { type: 'success' }).then(function () {
          _this5.$router.push(_this5.tablePath);
        });
      });
    }
  }
});

/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformAndroidapkTestForm_vue__ = __webpack_require__(2890);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11320984_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformAndroidapkTestForm_vue__ = __webpack_require__(5100);
function injectStyle (ssrContext) {
  __webpack_require__(5094)
  __webpack_require__(5096)
  this["$style"] = __webpack_require__(5098)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11320984"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformAndroidapkTestForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11320984_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformAndroidapkTestForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 5094:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5095);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("4dfcdb42", content, true, {});

/***/ }),

/***/ 5095:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PlatformAndroidapkTestForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5096:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5097);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("8dbcc7ac", content, true, {});

/***/ }),

/***/ 5097:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PlatformAndroidapkTestForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5098:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5099);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("b4501de8", content, true, {});

/***/ }),

/***/ 5099:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PlatformAndroidapkTestForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":_vm.tablePath}},[_vm._v("安卓APK白名单列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.uploading),expression:"uploading"}],attrs:{"element-loading-text":"正在上传APK文件，请稍候...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.7)"}},[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单（"+_vm._s(_vm.appTypeLabel)+"）")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.computedFormRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"名称","prop":"title"}},[_c('el-input',{attrs:{"disabled":this.form.userid > 0},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"安卓版本号","prop":"vision"}},[_c('el-input',{model:{value:(_vm.form.vision),callback:function ($$v) {_vm.$set(_vm.form, "vision", $$v)},expression:"form.vision"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"安卓APK包","prop":"loadurl"}},[_c('el-upload',{staticClass:"upload-demo",attrs:{"drag":"","limit":1,"accept":".apk","on-remove":_vm.handleRemove,"http-request":_vm.uploadRequest,"disabled":_vm.uploading,"action":"https://jsonplaceholder.typicode.com/posts/","multiple":""},model:{value:(_vm.form.loadurl),callback:function ($$v) {_vm.$set(_vm.form, "loadurl", $$v)},expression:"form.loadurl"}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("将文件拖到此处，或"),_c('em',[_vm._v("点击上传")])]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("只能上传APK文件")])])],1),_vm._v(" "),(_vm.isAlg)?_c('el-form-item',{attrs:{"label":"APK签名(md5)","prop":"apk_signature"}},[_c('el-input',{model:{value:(_vm.form.apk_signature),callback:function ($$v) {_vm.$set(_vm.form, "apk_signature", $$v)},expression:"form.apk_signature"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"IOS版本号","prop":"ios_version"}},[_c('el-input',{model:{value:(_vm.form.ios_version),callback:function ($$v) {_vm.$set(_vm.form, "ios_version", $$v)},expression:"form.ios_version"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"IOS下载链接","prop":"ios_loadurl"}},[_c('el-input',{model:{value:(_vm.form.ios_loadurl),callback:function ($$v) {_vm.$set(_vm.form, "ios_loadurl", $$v)},expression:"form.ios_loadurl"}})],1),_vm._v(" "),(_vm.isAlg)?_c('el-form-item',{attrs:{"label":"是否为白名单apk","prop":"type"}},[_c('el-radio-group',{on:{"change":function (value) {if (value === '0') { _vm.form.type = '' }}},model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}},[_c('el-radio',{attrs:{"label":1,"border":""}},[_vm._v("是\n              ")]),_vm._v(" "),_c('el-radio',{attrs:{"label":0,"border":""}},[_vm._v("不是\n              ")])],1)],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"强制升级","prop":"force_update"}},[_c('el-radio-group',{on:{"change":function (value) {if (value === '0') { _vm.form.force_update = '' }}},model:{value:(_vm.form.force_update),callback:function ($$v) {_vm.$set(_vm.form, "force_update", $$v)},expression:"form.force_update"}},[_c('el-radio',{attrs:{"label":1,"border":""}},[_vm._v("是\n              ")]),_vm._v(" "),_c('el-radio',{attrs:{"label":0,"border":""}},[_vm._v("不是\n              ")])],1)],1),_vm._v(" "),(_vm.isClb)?_c('el-form-item',{attrs:{"label":"是否开启热更新","prop":"enable_hot_update"}},[_c('el-radio-group',{on:{"change":_vm.onEnableHotUpdateChange},model:{value:(_vm.form.enable_hot_update),callback:function ($$v) {_vm.$set(_vm.form, "enable_hot_update", $$v)},expression:"form.enable_hot_update"}},[_c('el-radio',{attrs:{"label":1,"border":""}},[_vm._v("是\n              ")]),_vm._v(" "),_c('el-radio',{attrs:{"label":0,"border":""}},[_vm._v("否\n              ")])],1)],1):_vm._e(),_vm._v(" "),(_vm.isClb && Number(_vm.form.enable_hot_update) === 1)?_c('el-form-item',{attrs:{"label":"是否强制","prop":"force_hot_update"}},[_c('el-radio-group',{model:{value:(_vm.form.force_hot_update),callback:function ($$v) {_vm.$set(_vm.form, "force_hot_update", $$v)},expression:"form.force_hot_update"}},[_c('el-radio',{attrs:{"label":1,"border":""}},[_vm._v("是\n              ")]),_vm._v(" "),_c('el-radio',{attrs:{"label":0,"border":""}},[_vm._v("否\n              ")])],1)],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"更新日志"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.form.changelog),callback:function ($$v) {_vm.$set(_vm.form, "changelog", $$v)},expression:"form.changelog"}})],1)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("提交表单\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onReload}},[_vm._v("重置")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/platform-androidapk-test-form.09da068779c9da8b074a.js